import { css } from '@backyard-ui/styles';

export const gridStyles = css({
  display: 'flex',
  variants: {
    direction: {
      column: {
        flexDirection: 'column',
        '& > *:not(style) ~ *:not(style)': {
          marginTop: '$$spacing',
        },
      },
      'column-reverse': {
        flexDirection: 'column-reverse',
        '& > *:not(style) ~ *:not(style)': {
          marginBottom: '$$spacing',
        },
      },
      row: {
        flexDirection: 'row',
        '& > *:not(style) ~ *:not(style)': {
          marginLeft: '$$spacing',
        },
      },
      'row-reverse': {
        flexDirection: 'row-reverse',
        '& > *:not(style) ~ *:not(style)': {
          marginRight: '$$spacing',
        },
      },
    },
    wrap: {
      true: {
        flexWrap: 'wrap',
      },
    },
    isGrow: {
      true: {
        '& > div': {
          flexGrow: 1,
        },
      },
      false: {
        '& > div': {
          flexGrow: 0,
        },
      },
    },
  },
  defaultVariants: {
    direction: 'row',
    isGrow: false,
  },
});
